import Close from '@/app/_components/ui/icons/Close.svg';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Modal from 'react-modal';
import * as Yup from 'yup';
import { useUpdateQuestion } from '@/app/_hooks/useQuestion';
import { toast } from 'react-toastify';
import { useSession } from 'next-auth/react';
import LoadingIcon from '../../share/LoadingIcon';
import { useState } from 'react';

export default function AskAnswerForm({ openModal, onClose, productId }) {
  const updateQuestion = useUpdateQuestion();
  const { data: session } = useSession();
  const [isSendingForm, setIsSendingForm] = useState(false);
  const formSchema = Yup.object().shape({
    question: Yup.string().required('فیلد پرسش ضروری می باشد'),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(formSchema),
  });
  const submitQuestionForm = (values) => {
    const token = session?.user.accessToken;
    const question = values.question;
    setIsSendingForm(true);
    updateQuestion.mutate(
      { productId, question, token },
      {
        onSuccess: () => {
          setIsSendingForm(false);
          toast.dark('سوال شما با موفقیت ثبت شد');
          reset();
          onClose();
        },
      }
    );
  };

  return (
    <>
      <Modal
        isOpen={openModal}
        onRequestClose={onClose}
        ariaHideApp={false}
        portalClassName="modalAddComment"
        className="askAnswerModal"
        overlayClassName="modalOverlay"
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.75)',
          },
          content: {
            'max-width': '611px',
            background: '#fff',
            border: '1px solid gray',
            height: 'auto',
            overflowY: 'hidden',
          },
        }}
      >
        <div className="flex justify-between p-5 pb-1">
          <h2>ثبت پرسش</h2>
          <button onClick={onClose}>
            <Close />
          </button>
        </div>
        <div className="pt-2 pb-4">
          <div className="w-full border-t border-light-gray-200"></div>
        </div>
        <form
          className="w-full max-w-lg"
          id="addComment"
          onSubmit={handleSubmit(submitQuestionForm)}
        >
          <div className="flex  p-4">
            <div className="w-full mb-2 ">
              <textarea
                rows="6"
                placeholder="پرسش خود را درباره این کالا ثبت کنید؟"
                className="appearance-none block w-full  text-sm text-gray-900 border border-light-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                {...register('question')}
              ></textarea>
              <span className=" inputValidation text-xs text-red-800">
                {errors.question?.message}
              </span>
            </div>
          </div>
          <div className="p-4 flex justify-end">
            <button
              className="px-8 py-2 border-gray-500 border text-gray-500 text-sm rounded-md"
              type="button"
              onClick={onClose}
            >
              انصراف و بستن
            </button>
            <button
              className="px-8 py-2 bg-color-primary text-white text-sm rounded-md mr-4"
              type="submit"
              form="addComment"
              disabled={isSendingForm}
            >
              {isSendingForm ? <LoadingIcon /> : ' ثبت پرسش'}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
